export const TEACHER_FORM = 'addTeacher';
export const STUDENT_FORM = 'addStudent';
export const LOGIN_FORM = 'loginForm';
export const REGISTRATION_FORM = 'registrationForm';
export const RESET_PASSWORD_FORM = 'resetPasswordForm';
export const SEMESTER_FORM = 'addSemesterSuccess';
export const TEACHER_SCHEDULE_FORM = 'teacherScheduleForm';
export const SEMESTER_COPY_FORM = 'SemesterCopyForm';